// frontend/src/utils/authHelers.js

export const getToken = () => {
    return localStorage.getItem('access_token');
  };
  
  export const setToken = (token) => {
    localStorage.setItem('access_token', token);
  };
  
  export const removeToken = () => {
    localStorage.removeItem('access_token');
  };
  
  export const getDesign = () => {
    const design = localStorage.getItem('design');
    return design ? JSON.parse(design) : null;
  };
  
  export const setDesign = (designData) => {
    localStorage.setItem('design', JSON.stringify(designData));
  };
  
  export const removeDesign = () => {
    localStorage.removeItem('design');
  };
  
  export const logout = () => {
    removeToken();
    removeDesign();
  };
  